var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_138)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_198_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3359 5.05859V19.2256C18.3359 19.4464 18.2479 19.6583 18.0918 19.8145C17.9356 19.9706 17.7238 20.0586 17.5029 20.0586H2.50293C2.28204 20.0586 2.07025 19.9706 1.91406 19.8145C1.75787 19.6583 1.66992 19.4465 1.66992 19.2256V0.891602C1.66992 0.431602 2.0415 0.0585938 2.50293 0.0585938H13.3359L18.3359 5.05859Z",
    fill: "#1DB87B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2371 11.4506L13.7938 6.83203H11.6082L10.701 8.75643C10.4948 9.14131 10.3299 9.5743 10.1237 10.1035C10 9.86296 9.91753 9.62241 9.79381 9.42997C9.6701 9.18942 9.54639 8.94887 9.46392 8.75643L8.47423 6.83203H6.16495L8.72165 11.3544L6 16.1654H8.2268L9.25773 14.0966C9.46392 13.7118 9.62887 13.2788 9.91753 12.7014C10.0412 12.942 10.1237 13.1344 10.2474 13.3269C10.3711 13.5674 10.4948 13.8561 10.6186 14.0966L11.6907 16.1654H14L11.2371 11.4506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3301 0L18.3301 5H14.1644C14.0549 5.00019 13.9464 4.97878 13.8452 4.93701C13.744 4.89524 13.652 4.83392 13.5745 4.75657C13.497 4.67921 13.4356 4.58733 13.3936 4.48619C13.3517 4.38505 13.3301 4.27663 13.3301 4.16714V0Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_198_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.c3343accca226130b862d3dd5a63e0e5.svg";
export { ForwardRef as ReactComponent };